import { useEffect, useRef } from 'react'
import lottie from 'lottie-web'
import spinnerData from '../../../assets/images/smarttv/loading_spinner.json'
import styles from './LottieAnimation.module.scss' // Import the CSS module

export const LottieAnimation = ({ animationData, loop, onComplete, style = { height: '10vw' }, rendererSettings }) => {
	const animationContainer = useRef(null)

	useEffect(() => {
		const anim = lottie.loadAnimation({
			container: animationContainer.current,
			renderer: 'svg',
			loop: loop || false,
			autoplay: true,
			animationData: animationData || spinnerData,
			rendererSettings: rendererSettings || null,
		})

		anim.onComplete = function () {
			onComplete && onComplete()
		}

		return () => {
			anim.destroy()
		}
	}, [animationData, loop, onComplete])

	return <div ref={animationContainer} style={style}></div>
}

export default LottieAnimation
